import Vue from 'vue'
import App from './App.vue'
import { APP_CONFIG } from './config'
import router from './router'
import store from './store'
import './quasar'
import './assets/style/tokens.scss'
// Admin 主题防闪白：/admin 路径在 Vue 挂载前先挂 .dark（夜刷不先白屏）
import { initTheme } from './unit/theme'
if (/^\/admin(\/|$)/.test(window.location.pathname)) {
  initTheme()
}
import Element from 'element-ui'
import waterfall from 'vue-waterfall2'
import Vant from 'vant'
import 'vant/lib/index.css'
import VantIcons from 'vant/lib/icon'
import 'vant/lib/icon/style'
import { ImagePreview } from 'vant'
// elm css
import './assets/element-css/index.css'
import {
  Quasar,
  QResizeObserver,
  QParallax,
  QCarousel,
  QCarouselControl,
  QCarouselSlide,
  Notify,
  Dialog,
  QAvatar,
  QInput,
  QImg,
  QDialog,
  ClosePopup,
  QBtnToggle,
  QSkeleton,
  QMarkupTable,
  QSlideItem
} from 'quasar'
// axios
import axios from 'axios'
import Gettoken from './unit/gettoken'
import timeTool from '@/unit/timetool'
import VueAxios from 'vue-axios'
// input 自动对焦
import autofocus from 'vue-autofocus-directive'
// animate
import animate from 'animate.css'
import VueLazyload from 'vue-lazyload'
import baseTools from '@/unit/basetools'
import apiConfig from '@/config/api.config'
import { getImageUrl } from '@/utils/image'
// SVG图标组件
import SvgIcon from '@/components/common/SvgIcon.vue'
// 图片位统一原语
import AppImage from '@/components/common/AppImage.vue'
// 价格揭示组件（Price Visibility 2.0：无授权不渲染；有授权默认 **** 点击揭示）
import PriceReveal from '@/components/common/PriceReveal.vue'
// 商品卡装饰（边框系统一期：图片边框 L5 覆盖层 + 促销铭牌固定行）
import ProductFrame from '@/components/common/ProductFrame.vue'
import PromoBadges from '@/components/common/PromoBadges.vue'
// 图片裁剪组件
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

Vue.use(waterfall)
Vue.use(Element)
Vue.use(Vant)
Vue.use(VantIcons)
// 全局注册图片预览组件
Vue.use(ImagePreview)
Vue.use(VueLazyload)

// 全局注册SvgIcon组件
Vue.component('SvgIcon', SvgIcon)
// 全局注册AppImage组件
Vue.component('AppImage', AppImage)
// 全局注册PriceReveal组件（Price Visibility 2.0：浏览/履约场景统一"默认遮蔽-点击揭示"）
Vue.component('PriceReveal', PriceReveal)
// 全局注册商品卡装饰组件（卡片图片区/信息区统一渲染，页面按需摆放）
Vue.component('ProductFrame', ProductFrame)
Vue.component('PromoBadges', PromoBadges)

Vue.prototype.Gettoken = Gettoken
Vue.prototype.timeTool = timeTool
Vue.prototype.baseTools = baseTools
// 品牌展示单一来源（src/config APP_CONFIG）：模板里 {{ $brand.brandName }} / {{ $brand.brandNameZh }}
Vue.prototype.$brand = APP_CONFIG
Vue.prototype.$img = function (url, size) {
  // 空值返回 null，让调用方使用默认图
  if (!url || url === 'null' || url === 'undefined') return null
  // 1. 前缀处理
  let fullUrl
  if (url.includes('myqcloud.com')) {
    fullUrl = url
  } else if (url.startsWith('http://localhost:1580') || url.startsWith('http://127.0.0.1:1580')) {
    // serverBase='' (8080代理/部署同源) 语义下替换为空串=相对路径，代理/反代各自兜住；
    // 原 `|| 'http://localhost:1580'` fallback 在两种场景都产出死链，移除
    fullUrl = url.replace(/http:\/\/(localhost|127\.0\.0\.1):1580/, apiConfig.serverBase)
  } else if (url.startsWith('http') || url.startsWith('data:')) {
    fullUrl = url
  } else if (url.startsWith('/uploads/')) {
    fullUrl = apiConfig.serverBase + url
  } else {
    fullUrl = apiConfig.serverBase + (url.startsWith('/') ? url : '/' + url)
  }
  // 上传目录下的文件必须匹配命名规范（{timestamp}_{hex}.{ext}），
  // 不匹配 → 返回 null，避免发起必然 404 的请求
  if (fullUrl && fullUrl.indexOf('/images/uploads/') !== -1) {
    var filename = fullUrl.split('/').pop()
    if (!/^\d{13}_[a-f0-9]{16}\.\w+$/.test(filename)) {
      return null
    }
  }
  // COS 图按 size 拼缩略后缀（默认 medium 400px）；本地 /uploads、/images/uploads、data:、非 COS 域名不受影响
  return getImageUrl(fullUrl, size || 'medium')
}
Vue.directive('autofocus', autofocus)

// 设置 axios baseURL - 从统一配置读取
axios.defaults.baseURL = apiConfig.baseURL

// ===== 客户端环境快照（弱信号层：登录建立 session / refresh 更新时上报）=====
// 只采集轻量环境特征：屏幕/viewport/DPR/时区/语言/UA 与微信内置浏览器标志；
// 明确禁止指纹类采集（Canvas/WebGL/字体/AudioContext/MAC 地址/硬件序列号）。
// 服务端仅用于风险评估与审计（client_profile），不参与会话身份判定（device_id 仍是身份依据）。
// 每次调用取实时值——viewport/横竖屏随时变化，快照应反映当下。
function collectClientEnv () {
  try {
    return {
      screen_width: window.screen ? window.screen.width : 0,
      screen_height: window.screen ? window.screen.height : 0,
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      device_pixel_ratio: window.devicePixelRatio || 1,
      timezone: (Intl.DateTimeFormat().resolvedOptions().timeZone) || '',
      language: navigator.language || '',
      user_agent: navigator.userAgent || '',
      is_wechat: /MicroMessenger/i.test(navigator.userAgent || '')
    }
  } catch (_) {
    return null
  }
}

// 请求拦截器 - 自动添加token + auth 会话请求附带环境快照
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // 登录（建立 session）与 refresh（session 更新）附带 client_env；旧后端会忽略该字段
    const u = config.url || ''
    const isAuthPost = (config.method || 'get').toLowerCase() === 'post' &&
      (u.indexOf('/auth/login') !== -1 || u.indexOf('/auth/refresh') !== -1)
    const dataOk = config.data === undefined || (config.data instanceof Object && !(config.data instanceof FormData))
    if (isAuthPost && dataOk && !(config.data && config.data.client_env)) {
      const env = collectClientEnv()
      if (env) config.data = Object.assign({}, config.data, { client_env: env }) // 无 body 的 refresh 也要有载体
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// ===== 401 自动续期（Phase B：refresh session；single-flight 并发去重——非常重要）=====
// 同一时刻只允许一个 /auth/refresh 在飞；期间所有 401 请求挂起等它，成功后带新 token 重放一次
// （_retried 防死循环）。refresh 本身被拒（session 过期/撤销/风控）→ 清登录态回登录页，带 sess
// 参数给统一文案（不暴露风控细节）。
let refreshInFlight = null
function doRefresh () {
  if (!refreshInFlight) {
    refreshInFlight = axios.post('/auth/refresh').then(res => {
      if (res.data.code === 200 && res.data.data && res.data.data.token) {
        localStorage.setItem('token', res.data.data.token)
        return res.data.data.token
      }
      throw new Error('refresh_bad_response')
    }).finally(() => {
      refreshInFlight = null
    })
  }
  return refreshInFlight
}

function forceLogout (sess) {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  if (window.location.pathname === '/') return // 已在登录页：不跳转不打转
  const currentPath = window.location.pathname + window.location.search
  const q = ['redirect=' + encodeURIComponent(currentPath)]
  if (sess) q.push('sess=' + sess)
  window.location.href = '/?' + q.join('&')
}

// 响应拦截器 - 401 自动续期/权限不足提示
axios.interceptors.response.use(
  response => response,
  async error => {
    const status = error.response?.status
    const original = error.config || {}
    const url = original.url || ''
    if (status === 401) {
      // 登录/续期接口自身的 401 不再触发续期（防递归）；未登录态（无 token）直接放行清理
      const isAuthCall = url.indexOf('/auth/login') !== -1 || url.indexOf('/auth/refresh') !== -1 || url.indexOf('/auth/logout') !== -1
      if (!isAuthCall && !original._retried && localStorage.getItem('token')) {
        original._retried = true
        try {
          const newToken = await doRefresh()
          original.headers = original.headers || {}
          original.headers.Authorization = 'Bearer ' + newToken
          return axios(original) // 重放原请求（仅一次）
        } catch (refreshErr) {
          const msg = refreshErr && refreshErr.response && refreshErr.response.data && refreshErr.response.data.message
          forceLogout(msg && msg.indexOf('环境') !== -1 ? 'risk' : 'expired')
          return Promise.reject(error)
        }
      }
      // 帮助中心游客页（2026-09-17 用户拍板）：无 token 的 401 是角色鉴权的预期响应，不是
      // 会话失效——放行 reject 交给页面展示「登录后查看」引导卡，不 toast 也不跳登录
      const p = window.location.pathname
      const guestHelpPage = !localStorage.getItem('token') && (p === '/help' || p.startsWith('/help/'))
      if (!guestHelpPage) forceLogout('expired')
    } else if (status === 403) {
      // 权限不足，提示用户但不清除登录态
      const message = error.response?.data?.message || '无权限执行此操作'
      if (typeof this !== 'undefined' && this.$q) {
        this.$q.notify({ type: 'negative', message: message })
      } else {
        console.warn('权限不足:', message)
      }
    }
    return Promise.reject(error)
  }
)

Vue.use(Quasar, {
  plugins: {
    Notify,
    Dialog
  },
  config: {
    notify: { /* look at QUASARCONFOPTIONS from the API card (bottom of page) */ }
  },
  components: {
    QResizeObserver,
    QParallax,
    QCarousel,
    QCarouselControl,
    QCarouselSlide,
    Notify,
    QAvatar,
    QInput,
    QImg,
    QDialog,
    QBtnToggle,
    QSkeleton,
    QMarkupTable,
    QSlideItem
  },
  directives: {
    ClosePopup
  }
})
Vue.use(animate)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  VueAxios,
  axios,
  async beforeCreate () {
    // 应用启动时拉取可信用户信息（spec B/C：不信旧 localStorage user——角色可能在登录后
    // 被改（提权/降权/测试脚本翻转），token 有效但 user 对象过期 = "新 token + 旧 user"混合态）。
    // 只要 token 存在就向 /user/info 复核一次：store 空（首次打开/被踢后）await 首屏就位；
    // store 已有缓存 user 则后台静默校正——commit 后菜单/角标等 store 派生 UI 响应式自愈，
    // 无需刷新页面（这正是 super_admin 登录后侧栏缺菜单一类的状态残留根因）。
    const token = localStorage.getItem('token')
    if (!token) return
    const revalidate = async () => {
      try {
        const res = await axios.get('/user/info')
        if (res.data.code === 200 && res.data.data) {
          this.$store.commit('setUser', res.data.data)
        }
      } catch (err) {
        // 401 已由拦截器走续期/强制登出链；其余错误保留现有态不误清
        console.error('获取用户信息失败:', err)
      }
    }
    if (this.$store?.state?.user) {
      revalidate() // 后台校正：不阻塞挂载
    } else {
      await revalidate()
    }
  },
  render: h => h(App)
}).$mount('#app')

// 首屏骨架已随 #app 内部被 Vue 整体替换，移除其样式，不留死 CSS
const __rootSkStyle = document.getElementById('root-skeleton-style')
if (__rootSkStyle) __rootSkStyle.remove()
